import fetch from 'isomorphic-fetch';
import { cacheResponse } from '../actions/CacheActions';

const Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT'
};

const handleErrors = (response, errorPropName = 'statusText') => {
  if (!response.ok) {
    const error = new Error(response[errorPropName]);
    error.response = response;
    throw error;
  }
  return response;
};

const request = (url, options, returnType) => (
  fetch(url, options)
    .then(handleErrors)
    .then((response) => {
      if (returnType === 'text') {
        return response.text();
      }
      return response.json();
    })
);

const get = (url, options = {}, headers = {}, returnType = 'json') => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalOptions = {
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions, returnType);
};

const post = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalBody = JSON.stringify(body);
  const finalOptions = {
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions);
};

const put = (url, body = {}, options = {}, headers = {}) => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalBody = JSON.stringify(body);
  const finalOptions = {
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions);
};

// Deprecate the use of this and include in individual reducers
const cachedFetch = (url, options, dispatch, state) => (
  new Promise((resolve, reject) => {
    const cachedResponse = state && state.cache && state.cache[url];
    if (cachedResponse) {
      resolve(cachedResponse);
    } else {
      fetch(url, options)
        .then(handleErrors)
        .then(response => response.json())
        .then((json) => {
          dispatch(cacheResponse({ url, json }));
          resolve(json);
        })
        .catch(reject);
    }
  })
);

const ApiService = {
  request,
  get,
  post,
  put,
  cachedFetch,
  handleErrors
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/util/api.js